export enum featuresTypes {
    FETCH_FEATURES_REQUEST = 'FETCH_FEATURES_REQUEST',
    EDIT_FEATURES_REQUEST = 'EDIT_FEATURES_REQUEST',
    SET_FEATURES_ACTIVE = 'SET_FEATURES_ACTIVE',
    SET_FEATURES_INACTIVE = 'SET_FEATURES_INACTIVE',
}
